import React from 'react';

import { Btn, BtnLink } from './Button.styles';

const Button = ({ children, type, to, ...props }) => {
  if (type === 'link') {
    return (
      <BtnLink to={to} {...props}>
        {children}
      </BtnLink>
    );
  }
  return <Btn {...props}>{children}</Btn>;
};

export default Button;
